<template>
  <div>
    <v-container fluid>
      <v-card>
        <v-card-text>
          <v-form v-model="formValid">
            <v-jsonschema-form
              v-if="schema"
              :schema="schema"
              :model="dataObject"
              :options="options"
            />
            <v-btn @click="submitHandler">submit</v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      schema: {},
      dataObject: {},
      formValid: false,
      options: {
        debug: false,
        disableAll: false,
        autoFoldObjects: true
      }
    }
  },
  mounted() {
    this.initialize();
  },
  methods: {
    async initialize() {
      const schemaResponse = await this.$api.servers.getSchema();
      this.schema = await schemaResponse.data;

      console.log(this.schema);
    },
    submitHandler() {
      if (localStorage.getItem('access_token') != null) {
        this.$http.defaults.headers.common['X-Authorization'] = localStorage.getItem('access_token');
      }
      this.$http
        .post(this.schema.uri_api, this.dataObject)
        .then(r => {
          // console.log('r: ', JSON.stringify(r, null, 2));
          this.$router.push({name: 'servers'})
        });

    },
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/servers/add.vue